const { general } = require('./_general');

var quotes = {

    listen: function () {

        /**
         * This makes the tabs on the quote/job page change the url
         */
        $('#quoteTabs button[data-tab]').on('click', function() {
            const tabName = $(this).attr('data-tab');
            const currentUrl = window.location.pathname;
            const baseUrl = currentUrl.replace(/(\/(doors|notes|uploads|tasks|pos|sos|invoices|sales-orders|payments|history))+$/, '');

            
            // Update URL without page reload
            window.history.pushState({}, '', baseUrl + '/' + tabName);
        });

        /**
         * Customer request:
         * If "Flush" chosen in "Style" Header then default "Flush" in "Pattern" Header category
         */
        $("select[name='groove']", $("form#quote_spec_sheet_top")).on("change", function (event) {
            event.stopPropagation(); //
            let element = $(this);
            let specSheetTopForm = element.closest("form");
            let val = element.val();

            let patternEl = $("select[name='pattern']", specSheetTopForm);
            if (val == "FLUSH") {
                let optionToSelect = patternEl.find("option[value='FLUSH']");
                if (optionToSelect.length > 0) {
                    optionToSelect.prop("selected", true);
                    patternEl.trigger("change");
                }
            }

        });

        // Handle changes at the top of the spec sheet form (door skin type etc).
        $("select, input", $("form#quote_spec_sheet_top")).on("change", function (event) {

            quotes.handleSpecSheetSubmit(event, $(this)); 

        });


        /**
         * Hardware & Accessories table handler.
         */
        $("form#hardware_list_form, form#other_list_form").on("change", "select, input", function (event) {
            var el = $(this);

            // Product name (so selecting an item from the cin7 searchable values) we don't want to trigger this?
            // I'm guessing because it sets the product code, and that results in this triggering anyway.
            if (el.attr("name") == "product_name[]") {
                event.preventDefault();
                return false;
            } 
            
            quotes.handleDoorListSubmit($(this));
            quotes.lineValidation(event, $(this));
            quotes.roomValidation(event, $(this));
        });

        $("select, input[type=text], input[type=number], input[type=date]", $("form#quote_top_left")).on("change", function (event) { 
            quotes.handleTopLeftSubmit(event, $(this));
        });

        // When the product name changes we want to try find/load the product code
        $("body").on("select2:select", '#hardware_list_form select[name="product_name[]"]', function (event) {
            quotes.selectHardwareNameChanged(event, $(this), "hardware");
        });
        $("body").on("select2:select", '#other_list_form select[name="product_name[]"]', function (event) {
            quotes.selectHardwareNameChanged(event, $(this), "other");
        });

        $("a[role=add-line]").on("click", function (event) {
            quotes.addNewLine(event, $(this));
        })
        $("a[role=add-hardware-line]").on("click", function (event) {
            quotes.addNewHardwareLine(event, $(this)); 
        })
        $("a[role=add-other-line]").on("click", function (event) {
            quotes.addNewOtherLine(event, $(this)); 
        })
        $("a[role=add-cavity-line]").on("click", function (event) {
            quotes.addNewLine(event, $(this));
        })
        $("a[role=add-slider-line]").on("click", function (event) {
            quotes.addNewLine(event, $(this));
        })

        $("body").on("click", "a[role=delete-line]", function (event) {
            quotes.deleteLine(event, $(this));
        })

        $("body").on("click", "a[role=use-cin7-line]", function (event) {
            quotes.backToCin7Pricing(event, $(this));
        })

        /**
         * "Hide card details" toggle that sits against each section heading (Doors, Cavity
         * Sliders, Sliders). Delegated off body so it survives the headings being re-rendered
         * by Livewire (refreshHeadingsWithCount).
         */
        $("body").on("change", ".hide-card-details-toggle", function (event) {
            quotes.toggleCardDetails($(this));
        });

        $("body").on('select2:select', '#door_list_form select[name="type[]"]', function (event) {
            quotes.selectTypeChanged(event, $(this));
        });
        $("body").on('select2:select', '#door_list_form select[name="left_or_right[]"]', function (event) {
            quotes.selectLeftRightChanges(event, $(this));
        });

        $('#door_list_form select[name="hardware[]"]').on('select2:select', function (event) {
            quotes.selectHardwareChanged(event, $(this));
        });

        $(document).on('click', '[role="duplicate-line"]', function(event) {
            quotes.duplicateLine(event, $(this));
        });

        $(document).on('click', '[role="multiple-line-copies"]', function(event) {
            quotes.showMultipleCopyModal(event, $(this));
        });
        $(document).on('submit', 'form#copyMultipleDoorsForm', function(event) {
            quotes.handleMultipleCopyForm(event, $(this));
        });
        
        // $('#quote_top_left [name=customer_id]').on('select2:select', function (event) {
        //     quotes.customerChange(event, $(this));
        // }); 

        $("body").on("submit", "#addressForm", function (event) {
            quotes.addressUpdate(event, $(this));
        })

        // On load, and on dropdown change, fire the validation
        quotes.lineValidation(null, null);
        quotes.roomValidation();

        // Apply whatever the "Hide card details" checkboxes are set to on page load
        quotes.applyCardDetailToggles();
    },


    /**
     * Hides or shows the card bodies for one section (Doors, Cavity Sliders, Sliders).
     *
     * This works by putting a class on the section container rather than by looping the cards,
     * so that any card added afterwards - addNewLine, duplicateLine, handleMultipleCopyForm -
     * picks up the current state on its own without those methods needing to know about this.
     *
     * @param {jQuery Element} checkbox - the .hide-card-details-toggle, with data-target set to
     *      the section container selector (i.e. ".door-cards")
     */
    toggleCardDetails: function (checkbox) {

        let container = $(checkbox.data("target"));

        if (!container.length) {
            return;
        }

        container.toggleClass("hide-card-details", checkbox.is(":checked"));
    },

    /**
     * Run every "Hide card details" checkbox through toggleCardDetails so the page matches the
     * checkboxes on load. They're checked by default in the markup, so details start hidden.
     */
    applyCardDetailToggles: function () {

        $(".hide-card-details-toggle").each(function () {
            quotes.toggleCardDetails($(this));
        });
    },


    /**
     * Instead of just "Duplicate Line" we want a little modal where you can duplicate X times.
     */
    showMultipleCopyModal: function(event, linkEl) {
        event.preventDefault();

        let modalEl = $('#copyMultipleDoorsModal');

        modalEl.data('route', linkEl.data('route'));
        modalEl.data('container', linkEl.closest('.door-cards, .cavity-cards, .slider-cards')[0]);

        let modal = new window.bootstrap.Modal(modalEl[0], {});
        modal.show();
    },

    handleMultipleCopyForm: function(event, formEl) {
        event.preventDefault();

        let modalEl = $('#copyMultipleDoorsModal');
        let route = modalEl.data('route');
        let container = $(modalEl.data('container'));
        let quantity = parseInt(formEl.find('[name=copy_count]').val(), 10);

        let isCustomerMode = window.location.href.includes('/customer-area/');
        let data = {
            customerMode: isCustomerMode ? '1' : '0',
            quantity: quantity
        };

        // Pretty much just copying duplicateLine below.
        $.post(route, data, function(response) {


            
            let $markup = $(response.markup);
            
            console.log("markup", $markup);
            console.log("container", container.length)
            console.log("modalEl", modalEl)
            container.find('.card-wrap').last().after($markup);
            
            general.flashCard($markup.find('.card'));

            Livewire.dispatch('refreshHeadingsWithCount'); 
            general.initTooltips();

            bootstrap.Modal.getInstance(modalEl[0]).hide();

        }, "json");
    },

    duplicateLine: function(event, linkEl) {
        
        event.preventDefault();

        // It'll be either a door or cavity card we're copying, so whatever parent section.
        let container = linkEl.closest('.door-cards, .cavity-cards, .slider-cards');

        // Check if we're in customer area
        let isCustomerMode = window.location.href.includes('/customer-area/');
        
        let data = {
            customerMode: isCustomerMode ? '1' : '0'
        };

        $.post(linkEl.data("route"), data, function (response) {
                        
            let markup = $(response.markup);

            // Put it as the last card
            container.find('.card-wrap').last().after(markup);

            let card = markup.find(".card"); // This is a door card but it has a .card-wrap around it

            // This'll flash the header/footer yellow as well as scroll to it
            general.flashCard(card)

            // Update the counts next to the headings
            Livewire.dispatch('refreshHeadingsWithCount');

            // Init any new tooltips (i.e. incomplete pricing)
            general.initTooltips();

        }, "json");
    },

    /**
     * Scrolls to a card element and flashes it with a yellow highlight
     * @param {jQuery Element} cardElement - The card element to scroll to and flash
     */
    flashCard: function(cardElement) {
        $('html, body').animate({ scrollTop: cardElement.offset().top - 100 }, 300, function() {
            let headersAndFooters = cardElement.find('.card-header, .card-footer');
            headersAndFooters.css('background-color', '#ffff99');
            headersAndFooters.animate(
                { backgroundColor: 'transparent' }, 
                1000
            );
        });
    },


    /**
     * Scan the door lines on the page.
     * If a room has multiple lines, highlight them.
     */
    roomValidation: function (event, element) {

        var doorLines = $("form#door_list_form .door_list_line");

        var rooms = {};

        $("td.roomtd", doorLines).removeClass("validation-error");

        doorLines.each(function(index) {
            var tableRow = $(this);
            var roomEl = $('[name="room[]"]', tableRow);
            var roomValue = roomEl.val();

            if (rooms[roomValue] === undefined) {
                rooms[roomValue] = 1;
                return;
            }

            rooms[roomValue]++

            // If we've got here, we know we've already got this room in use. Highlight both rooms.
            var selects = $('[name="room[]"]:has(option[value="' + roomValue + '"]:selected)');
            
            selects.each(function(index) {
                var select = $(this);
                select.closest("td").addClass("validation-error");
            });
        });

    },

    lineValidation: function(event, element) {
        
        // If we have a form field that triggered this, get its parent door list line to process.
        if (element) {
            var lineElements = element.closest(".door_list_line");

            lineElements.find("*").removeClass("validation-error");

            // # Update # Client now wants to make sure all empty fields are highlighted
            // Only want to run this if the jamb, style or arch has triggered this
            // if (!["jamb[]", "style[]", "arch_type[]", "type[]"].includes(element.attr("name"))) {
            //     return;
            // }
        } 

        // If we don't, we want to validate ALL rows on the page.
        else {
            var lineElements = $(".door_list_line");
        }

        lineElements.each(function(index, htmlElement) {

            console.log("VALIDATING THE LINE")
            var element = $(htmlElement);

            // No validation on the hardware lists. This stops having to manually check for all these fields below
            if (element.hasClass("hardware_list_line")) {

                // Now if any field is left empty they want to highlight it.
                $("select, input", element).each(function(index, element) {
                    
                    element = $(element);

                    if (element.val() == "") {
                        element.closest("td").addClass("validation-error"); 
                    }
                });

                return;
            }

            //element.removeClass("validation-error");

            var jambEl = $("[name='jamb[]']", element);
            var styleEl = $("[name='style[]']", element);
            var archEl = $("[name='arch_type[]']", element);
            var typeEl = $("[name='type[]']", element);
            var skinEl = $("[name='skin[]']", element);
            var leftOrRightEl = $("[name='left_or_right[]']", element);
            var trackEl = $("[name='track[]']", element);
            var pivotGearEl = $("[name='pivot_gear[]']", element);


            /**
             * Flag red (or another colour) if Standard & V Grove are selected as you can't have 
             * that combination, or dont allow it, whatever you think is best, quick and easiset.
             */
            if (skinEl.val() == "STANDARD" && styleEl.val() == "V Groove") {

                skinEl.closest("td").addClass("validation-error");
                styleEl.closest("td").addClass("validation-error");
            } else {
                skinEl.closest("td").removeClass("validation-error");
                styleEl.closest("td").removeClass("validation-error");
            }


            // If 2 piece jamb selected, an arch must be selected
            if (["38mm 2 piece", "42mm 2 piece", "42 mm 2 piece"].includes(jambEl.val())) {
            
                // If arch not selected, show error
                if (archEl.val() == "" || archEl.val() == "No Arch") {
                    archEl.closest("td").addClass("validation-error");
                }

            }

            // If 38mm selected, can't select v groove 
            if (["38mm 2 piece"].includes(jambEl.val())) {
                
                // If arch not selected, show error
                if (styleEl.val() == "V Groove") {
                    styleEl.closest("td").addClass("validation-error");
                }

            }
            
            // If type is changed to "Slider", we can't have "flat jamb"
            if (typeEl.val().includes("Slider") && jambEl.val().includes("Flat Jamb") ) {
                jambEl.closest("td").addClass("validation-error");
            }

            // Now if any field is left empty they want to highlight it.
            $("select, input", element).each(function(index, input) {
                
                let inputEl = $(input);

                /**
                 * Client wanted track to only be highlighted red if
                 */
                if (inputEl.attr("name") == "track[]") {
                    let typeEl = $("[name='type[]'", element);
                    let containsCavity = typeEl.val().toUpperCase().includes("CAVITY");

                    // Anything but cavity sliders need a track
                    if (containsCavity == false || typeEl.val() == "") {
                        inputEl.closest("td").addClass("validation-error");    
                    }
                }
                else if (inputEl.attr("name") == "pivot_gear[]") {
                    let typeEl = $("[name='type[]'", element);
                    let containsCavity = typeEl.val().toUpperCase().includes("CAVITY");

                    // Anything but cavity sliders need a track
                    if (containsCavity == false || typeEl.val() == "") {
                        inputEl.closest("td").addClass("validation-error");    
                    }
                }
                
                else if (inputEl.val() == "") {
                    inputEl.closest("td").addClass("validation-error"); 
                }
            });


            // Trigger a change event on the left/right field so the validation kicks in
            leftOrRightEl.trigger("select2:select");
            
        });

    },

    addressUpdate: function (event, form) {
        event.preventDefault();

        $.ajax({
            type: "post",
            url: form.attr("action"),
            data: form.serializeArray(),
            dataType: 'json',
            success: function (data) {
                $(".ajaxError").remove();

                //$("#addressModal").modal("hide");

                // var myModalElement = document.getElementById('addressModal');
                // var myModal = new bootstrap.Modal(myModalElement);
                // myModal.hide();

                //quotes.handleTopLeftSubmit();
                
                // @todo This is shit - but having issues
                window.location.reload(); 

            },
            error: function (err) {
                if (err.status == 422) { // when status code is 422, it's a validation issue
                    console.log(err.responseJSON);

                    $('#success_message').fadeIn().html(err.responseJSON.message);

                    // you can loop through the errors object and show it to the user
                    console.warn(err.responseJSON.errors);
                    // display errors on each form field
                    $.each(err.responseJSON.errors, function (i, error) {
                        var el = $(document).find('[name="' + i + '"]');
                        el.after($('<span style="color: red;" class="ajaxError">' + error[0] + '</span>'));
                    });
                }
            }
        });

    },

    selectHardwareChanged: function (event, element) {

        var tableRow = element.closest(".door_list_line");
        var td = element.closest("td");

        var data = event.params.data;
        var value = data.element.value;
        
        var roomEl = $('[name="room[]"]', tableRow);
        var roomValue = roomEl.val();

        td.removeClass("validation-error");
        if (roomValue.includes("Bath") && value.includes("Passage")) {
            td.addClass("validation-error");
        }

    },

    selectTypeChanged: function (event, element) {

        var row = element.closest(".door_list_line");

        var data = event.params.data;
        var value = data.element.value;
        
        // The client wants anything "double" to pick left and right.
        // I did ask if things like "Double Slider" should instead be slider, but no it's "Left & Right".
        var changeTo = null;
        if (value.includes("Double")) {
            changeTo = "Left & Right";
        } else if (value == "Single Cavity Slider") {
            changeTo = "Slider";
        }

        if (changeTo) {
            var leftRightField = $("[name='left_or_right[]']", row).select2();
            leftRightField.val(changeTo).trigger("change");
        }

        if (value.includes("Single")) {
            
            var leftRightField = $("[name='left_or_right[]']", row).select2();

            leftRightField.closest("td").removeClass("validation-error");

            if (leftRightField.val() == "Left & Right") {
                leftRightField.closest("td").addClass("validation-error");
            }
        }

    },

    /**
     * If we change the left/right value, make sure the "Type" values matches.
     * If we've got "Left & Right" selected, highlight red if the type is "Single" for example as
     * a single door can't be left and right.
     * 
     */
    selectLeftRightChanges: function(event, element) {

        let row = element.closest(".door_list_line");
        
        let td = element.closest("td");

        let leftRightField = $("[name='left_or_right[]']", row);
        let typeField = $("[name='type[]']", row);

        let leftRightVal = leftRightField.val();
        let typeVal = typeField.val();
        let error = false;


        // Single doors can't be "Left & Right"
        if (leftRightVal == "Left & Right" && typeVal == "Single") {
            error = true
        }
        
        // Double can't be just "Left" or "Right".
        if (typeVal == "Double" && ["Left", "Right"].includes(leftRightVal)) {
            error = true
        }
        
        
        if (error) {
            td.addClass("validation-error");
        } else {
            td.removeClass("validation-error");
        }
        
    },


    /**
     * When an item is searched for and selected, we pre-populate the read only item code field.
     * 
     * In 2026 we expanded this to allow entering custom items (with the "tags: true" option on select2).
     * When a custom item is selected, we set the item to "Adhoc" for reasons in email subject "Re: Invoice notes".
     * We also unlock the cost/style/finish fields on those lines. NOTE: This requires template changes in _hardware-list-line
     * too so on page load they're also unlocked on those fields where appropriate.
     * 
     * @param {JavaScript event} event 
     * @param {jQuery element} element 
     * @param {string} hardwareOrOther - "hardware" or "other" since this is used for both tables
     */
    selectHardwareNameChanged: function (event, element, hardwareOrOther) {

        
        let row = element.closest(".door_list_line");

        // The props for this are defined in initHardwareSelect2() - but basically fields straight from pricing row.
        let data = event.params.data;

        let supplierEl = row.find("[name='hardware_supplier_cin7_id[]']");
        let codeEl = row.find("[name='product_code[]']");
        let styleEl = row.find("[name='hardware_style[]']");
        let finishEl = row.find("[name='hardware_finish[]']");
        let costEl = row.find("[name='cost[]']");

        /**
         * If this is a user entered value (not one from the autocomplete values) we won't have a code property
         * so we know it's user entered.
         * 
         * We'll also unlock style etc for editing
         */
        let userEntered = data.code === undefined ? true : false;
        if (userEntered) {

            // Email subject "Re: Invoice notes" - to do with smart buyer in Cin7
            codeEl.val("Adhoc");

            if (hardwareOrOther == "hardware") {
                styleEl.prop("readonly", false);
                finishEl.prop("readonly", false);
            }

            costEl.prop("readonly", false);

        } 
        
        /**
         * Not user entered - so we can auto populate these and make sure they're read only again!
         */
        else {

            // Lock these again
            if (hardwareOrOther == "hardware") {
                styleEl.prop("readonly", true);
                finishEl.prop("readonly", true);
            }
            costEl.prop("readonly", true);

            // Data comes form the autocomplete
            codeEl.val(data.code); 

            if (hardwareOrOther == "hardware") {
                styleEl.val(data.finish);
            }

            // This is a Select2. Need to trigger
            supplierEl.val(data.supplierId).trigger('change');
        }

        
        // Any changes in these line trigger a refresh - OTHER than name (it's excluded in the listener)
        // because this runs too quickly. So manually trigger a submit.
        quotes.handleDoorListSubmit(element.closest("form"));  

    },


    deleteLine: function (event, element) {
        event.preventDefault();
        var route = element.data("route");

        $.post(route, [], function (response) {
            
            // This is the old table based system 
            element.closest(".door_list_line").remove();
            
            // New card layout
            element.closest(".card-wrap").remove();

            // Update the counts next to the headings
            Livewire.dispatch('refreshHeadingsWithCount');

            // Update quote totals
            Livewire.dispatch('update-quote-totals');

        }, "json");
    },


    backToCin7Pricing: function (event, element) {
        event.preventDefault();
        var route = element.data("route");

        $.post(route, [], function (response) {
            
            // New card system - replace with updated markup
            var card = element.closest('[data-lineid]');
            if (card.length > 0) {

                let newCard = $(response.markup);
            
                card.replaceWith(newCard);
                
                general.initSelect2(newCard);
                general.initHardwareSelect2(newCard);
                
            } 

            // Update quote totals
            Livewire.dispatch('update-quote-totals');
            
        }, "json");
    },

    /**
     * Combined method for adding a new door or cavity slider line to a quote or job.
     * 
     * @param {jQuery Event} event 
     * @param {jQuery Element} element 
     * @returns {void}
     */
    addNewLine: function (event, element) {
        event.preventDefault();

        // Don't allow double clicking
        if (element.hasClass('loading')) {
            return false;
        }

        let route = element.data("route");
        
        // Add the loading animation and lock out the button from being clicked.
        this._setAddNewButtonLoading(element, true);

        // Check if we're in customer area - not the best but don't want to pass in stuff down so many views
        let isCustomerMode = window.location.href.includes('/customer-area/');
        
        let data = {
            customerMode: isCustomerMode ? '1' : '0'
        }
        
        $.post(route, data, function (response) {
            if (response.success) {
                var markup = response.markup;
                
                // Add to either doors or cavities depending on kindo f button.
                let containerSelector = '.door-cards';
                if (element.attr('role') === 'add-cavity-line') {
                    containerSelector = '.cavity-cards';
                } else if (element.attr('role') === 'add-slider-line') {
                    containerSelector = '.slider-cards';
                }
                
                $(containerSelector).append(markup);

                // Find the edit button in the newly added card and click it to open the modal
                var newCard = $(containerSelector).children().last();
                var editButton = newCard.find('[role="edit-door-modal"]');
                
                editButton.trigger("click");

                // Update the counts next to the headings
                Livewire.dispatch('refreshHeadingsWithCount');

                general.flashCard(newCard)


            }
        }, "json")
        .always(function() {
            // Set it back even if we have an error or something.
            quotes._setAddNewButtonLoading(element, false);
        });
    },


    /**
     * This is just for the add door/add cavity slider buttons
     */
    _setAddNewButtonLoading: function(button, isLoading) {
        if (isLoading) {
            button.addClass('loading')
                .prop('disabled', true)
                .data('original-html', button.html())
                .html('<i class="fas fa-spinner fa-spin me-2"></i>Adding...');
        } else {
            button.removeClass('loading')
                .prop('disabled', false)
                .html(button.data('original-html'));
        }
    },

    addNewHardwareLine: function (event, element) {
        event.preventDefault();
        var route = element.data("route");

        $.post(route, [], function (response) {
            var markup = response.markup;
            $("#hardware_lines_table tbody").append(markup);

            general.initSelect2($("#hardware_lines_table tr:last"));
            general.initHardwareSelect2($("#hardware_lines_table tr:last"));

            // Update the counts next to the headings
            Livewire.dispatch('refreshHeadingsWithCount');

        }, "json");
    },

    addNewOtherLine: function (event, element) {
        event.preventDefault();
        var route = element.data("route");

        $.post(route, [], function (response) {
            var markup = response.markup;
            $("#other_lines_table tbody").append(markup);

            general.initSelect2($("#other_lines_table tr:last"));
            general.initHardwareSelect2($("#other_lines_table tr:last"));

            // Update the counts next to the headings
            Livewire.dispatch('refreshHeadingsWithCount');

        }, "json");
    },

    handleTopLeftSubmit: function (event, element) {

        var form = $("form#quote_top_left");
        var data = form.serializeArray();


        $.post(form.attr("action"), data, function (response) {

            var addressMarkup = response.addressModalMarkup; 
            $("#quoteAddressModal").replaceWith(addressMarkup);

            general.initSelect2($("#quoteAddressModal"));

            // Customer notes from the CRM. Follows a change of customer, and hides when the new
            // customer has none. The alert isn't on the page at all in customer mode.
            let notesAlert = $("#customer-notes-alert");
            if (notesAlert.length) {
                $("#customer-notes-text").text(response.customerNotes || "");
                notesAlert.toggleClass("d-none", !response.customerNotes);
            }

            // Parent company under the customer select. Hidden when the new customer has none.
            $("#customer-parent-name").text(response.customerParentName || "");
            $("#customer-parent").toggleClass("d-none", !response.customerParentName);
            
        }, "json");

    },

    handleSpecSheetSubmit: function (event, element) {
        var form = $("form#quote_spec_sheet_top");
        var data = form.serializeArray();
    
        $.post(form.attr("action"), data, function (response) {
            
            /**
             * Customer wanted change of items in spec sheet (like hunge) to update all the validation (which 
             * involves recalculating pricing) for all line items. 
             * 
             * I recommended no but this fires off ajax requests to update every single
             */
            // $("#door_list_form [name='room[]']").trigger("change");
            // $("#cavity_list_form [name='room[]']").trigger("change");
            // $("#hardware_list_form [name='qty[]']").trigger("change");

            // Triggering one line submits the whole lot.
            $("#door_list_form [name='room[]']:first").trigger("change");
            $("#cavity_list_form [name='room[]']:first").trigger("change");
            $("#hardware_list_form [name='qty[]']:first").trigger("change");
        }, "json");
    },
    

    handleDoorListSubmit: function (element) {

        // Get the form and serialize the data
        var form = element.closest("form");
        var data = form.serializeArray();
    
        // Need to send the field that triggered the event
        var originLineItemRow = element.closest('.door_list_line');
        var origin = "";
        if (originLineItemRow.length) {
            origin = element.attr("name").replace(/\[\]/g, "") + "," + originLineItemRow.data("lineid");
        }
        data.push({name: "origin", value: origin});
    
        // Show the loading spinner overlay
        var $overlay = $('<div class="overlay"><div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div></div>');
    
        // Add overlay styling and append it to the form (or its closest parent)
        form.css('position', 'relative');  // Ensure the form has relative positioning
        $overlay.css({
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.7)', // Transparent white background
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999 // Ensure it appears above everything else
        });

    
        $.post(form.attr("action"), data, function (response) {
    
            // This loops through all the line items in the response, matches them to the line on the page, and updates the value.
            response.lines.forEach(function(line) {
    
                let id = line.id;
                let lineItemRow = $(".door_list_line[data-lineid='" + id +"']");
                let priceEl = $("[name='price[]']", lineItemRow);
                let priceWrapEl = priceEl.closest("td");
                let costEl = $("[name='cost[]']", lineItemRow);
                let subtotalEl = $("[name='subtotal[]']", lineItemRow); 

                if (line.user_has_set_price) {
                    priceEl.closest("td").addClass("custom-price-col");
                }
    
                if (line.user_has_set_cost) {
                    priceEl.closest("td").addClass("custom-price-col");
                }
    
                priceEl.val(line.price);
                costEl.val(line.cost);
                subtotalEl.val(line.subtotal);
    
                // Add incomplete pricing or multi-pricing rows highlighting here
                if (line.pricing_incomplete) {
                    priceWrapEl.addClass("incomplete-pricing");
                } else {
                    priceWrapEl.removeClass("incomplete-pricing");
                }
    
                if (line.multi_pricing_detected) {
                    priceWrapEl.addClass("multi-pricing-detected");
                } else {
                    priceWrapEl.removeClass("multi-pricing-detected");
                }
    
            });

            // Update the totals too
            Livewire.dispatch('update-quote-totals');
    
        }, "json")
        .always(function() {
            // Hide the loading spinner once the AJAX call is complete
            //$overlay.remove();
        });
    
    }
    

    

}

$(function () {
    quotes.listen()
});

module.exports = {
    quotes
};